import React, {useState, useEffect, useContext} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {isNull} from "lodash";
import GMap from "../components/GMap";
import Widgets from "../components/Widgets";
import FiltersContext from "../../restaurantsMap/FiltersContext";
import getListDivisions from "../../restaurantsMap/helpers/getListDivisions";
import getListBrands from "../../restaurantsMap/helpers/getListBrands";
import getListCountries from "../../restaurantsMap/helpers/getListCountries";
import mapData from "../../restaurantsMap/helpers/mapData";

const RestaurantsMapBrands = ({}) => {
  const language = drupalSettings.path.currentLanguage || '';

  const ENDPOINTS = {
    divisions: '/' + language + '/api/taxonomy/divisions',
    countries: '/' + language + '/api/taxonomy/countries',
    brands: '/' + language + '/api/taxonomy/brands',
    brandsInCountries: '/' + language + '/api/taxonomy/brands_in_countries'
  }

  const [loaded, setLoaded] = useState(false);
  const [statusIcon, setStatusIcon] = useState(null);
  const [data, setData] = useState(null);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [selectedRestaurants, setSelectedRestaurants] = useState(null);
  const [currentMapPosition, setCurrentMapPosition] = useState({
    geoCords: {lat: 46.8180763, lng: 13.0926671},
    zoom: 1
  });
  const [availableOptions, setAvailableOptions] = useState({
    countries: [],
    divisions: [],
    brands: []
  });

  useEffect(() => {
    axios
      .all(
        [
          axios.get(ENDPOINTS.divisions),
          axios.get(ENDPOINTS.countries),
          axios.get(ENDPOINTS.brands),
          axios.get(ENDPOINTS.brandsInCountries)
        ])
      .then(axios.spread((...responses) => {
        if (responses[0].status === 200 &&
          responses[1].status === 200 &&
          responses[2].status === 200 &&
          responses[3].status === 200) {
          let mappedData = mapData(responses[0].data, responses[1].data, responses[2].data, responses[3].data);

          setData(mappedData);
          setLoaded(true);
          setAvailableOptions({
            divisions: getListDivisions(mappedData.countries),
            countries: getListCountries(mappedData.countries),
            brands: getListBrands(mappedData.countries)
          });
        } else {
          setStatusIcon("fas fa-exclamation-triangle py-3");
        }
      }))
      .catch(err => {
        setStatusIcon("fas fa-exclamation-triangle py-3");
      });
  }, []);

  const contextValue = {
    data: data,
    currentFilters: currentFilters,
    initMapPosition: {
      geoCords: {lat: 46.8180763, lng: 13.0926671},
      zoom: 1
    },
    setCurrentFilters: item => setCurrentFilters(item),
    currentMapPosition: currentMapPosition,
    setCurrentMapPosition: item => setCurrentMapPosition(item),
    availableOptions: availableOptions,
    setAvailableOptions: item => setAvailableOptions(item),
    selectedRestaurants: selectedRestaurants,
    setSelectedRestaurants: item => setSelectedRestaurants(item)
  };

  if (loaded === true) {
    return (
      <FiltersContext.Provider value={contextValue}>
        <Widgets/>
        <GMap/>
      </FiltersContext.Provider>
    );
  } else {
    if (isNull(statusIcon)) {
      return (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">{Drupal.t("Loading...")}</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-center">
          <i className={`${statusIcon}`}></i>
        </div>
      );
    }
  }
};

RestaurantsMapBrands.propType = {
  endpoint: PropTypes.string.isRequired
};

export default RestaurantsMapBrands;
